import { FieldHasValue } from 'helpers/Validation';

export const AsLeftResultFormula = (formData) => {
    if (
        FieldHasValue(formData.F428AltSmokeDetectorHousing)
        && FieldHasValue(formData.F378AltHmistatus1)) {
        if (formData.F428AltSmokeDetectorHousing === 'YES' && formData.F378AltHmistatus1 === 'ALARM') {
            return 'PASS';
        }
        return 'FAIL';
    }
    return '';
};
